import { GlobalState } from '../types';

import { MerchantPosesState } from './types';

export const merchantPosesSelector: (state: GlobalState) => MerchantPosesState = (state: GlobalState) =>
  state.merchantPoses;
